import { render, staticRenderFns } from "./blockedReport.vue?vue&type=template&id=a319b906"
import script from "./blockedReport.vue?vue&type=script&lang=js"
export * from "./blockedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports